import React from 'react';
import * as S from './styles';
type ImageViewerProps = {
  gallery: string[];
};
const ImageViewer: React.FC<ImageViewerProps> = ({
  gallery
}) => {
  return <S.ContainerDiv data-testid="image-gallery-viewer">
      <S.ImageContainerDiv>
        {gallery?.map((image: string, idx: number) => <S.Image key={image + '_' + idx} src={image} />)}
      </S.ImageContainerDiv>
    </S.ContainerDiv>;
};
export default ImageViewer;